import { Box } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { ImpactUpdated } from "~/components/impact/Updated/impact-updated";

export function ImpactCell(params: GridRenderCellParams<any, number>) {
  const row = params.row;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}
    >
      <ImpactUpdated
        impact={{ rating: row.rating, value: row.riskValue || 0 }}
        isActive={true}
        isRiskScore
        hideTooltip={false}
      />
    </Box>
  );
}
